
export function Pin()
{
	return <svg id="pin" class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 0C19.9 0 10 9.9 10 22c0 4.4 1.3 8.7 3.8 12.3L32 63.8l18.2-29.4c2.5-3.7 3.8-8 3.8-12.4C54 9.9 44.1 0 32 0zm0 31c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"/></svg> ;
}
